import { render, staticRenderFns } from "./Mostruario.vue?vue&type=template&id=95ab68fc&scoped=true"
import script from "./Mostruario.vue?vue&type=script&lang=js"
export * from "./Mostruario.vue?vue&type=script&lang=js"
import style0 from "./Mostruario.vue?vue&type=style&index=0&id=95ab68fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ab68fc",
  null
  
)

export default component.exports